import { render } from "./remains.vue?vue&type=template&id=10f2478a&lang=pug"
import script from "./remains.vue?vue&type=script&lang=js"
export * from "./remains.vue?vue&type=script&lang=js"

import "./remains.vue?vue&type=style&index=0&id=10f2478a&lang=less"

import exportComponent from "/home/runner/work/product-2022-dapp-front/product-2022-dapp-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__